import React from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { mq, breakpoints } from '@styles/breakpoints';
import { TestId } from '@components/test-ids';
import { Grid } from '@mui/material';
import { LazyLoadBackgroundImage } from '@components/common/lazy-load';
import { RippleCard } from '@components/common/ripple-card';
import { getImageUrl } from '@util/images';
import { mixins } from '@styles/mixins';
import { ThemeProps } from '@theme/base';

export interface BaseCardProps {
  image?: string;
  className?: string;
  renderBody: () => React.ReactNode;
  testId?: string;
  disableRipple?: boolean;
}

const Container = styled.div(({ theme }: ThemeProps) => ({
  ...mixins(theme).card,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  overflow: 'hidden',
  flex: 1,
  [mq.small]: {
    flexDirection: 'row'
  }
}));

const ImageContainer = styled.div({
  position: 'relative',
  height: '100%'
});

const Image: any = styled(LazyLoadBackgroundImage)({
  width: '100%',
  height: 230,

  [mq.small]: {
    height: '100%'
  }
});

const Body: any = styled.div(({ theme }: ThemeProps) => ({
  padding: theme.custom.spacing.large,
  width: '100%'
}));

export const BaseCard = ({ image, renderBody, testId, className, disableRipple }: BaseCardProps) => {
  const hasImage: boolean = !!image;
  const bodyGridSize = hasImage ? 6 : 12;

  return (
    <RippleCard disabled={disableRipple}>
      <Container data-testid={testId || TestId.card.base} className={className}>
        <Grid container spacing={0}>
          {hasImage && (
            <Grid item xs={12} sm={6}>
              <ImageContainer>
                <Image src={/\?\w+=/.test(image!) ? image : getImageUrl(image!, breakpoints.large)} />
              </ImageContainer>
            </Grid>
          )}
          <Grid item xs={12} sm={bodyGridSize}>
            <Body>{renderBody()}</Body>
          </Grid>
        </Grid>
      </Container>
    </RippleCard>
  );
};

export default withTheme(BaseCard);
